export const statusIDFilterOptions = [
  {label: 'הזמנה חדשה', value: '1'},
  {label: 'בטיפול', value: '2'},
  {label: 'הזמנה בוצעה', value: '3'},
  {label: 'שליחה נכשלה', value: '4'},
  {label: 'בוצע ידנית', value: '5'},
]

export const paymentTypeOptions = [
  {
    value: 1,
    label: "שיק"
  },
  {
    value: 2,
    label: "מזומן"
  },
  {
    value: 3,
    label: "נ.מס במקור"
  },
  {
    value: 4,
    label: "ישראכרט"
  },
  {
    value: 5,
    label: "אשראי"
  },
  {
    value: 6,
    label: "ויזה אלפא"
  },
  {
    value: 7,
    label: "דיינרס"
  },
  {
    value: 8,
    label: "אמריקן אקספרס"
  },
  {
    value: 9,
    label: "העברה בנקאית"
  },
  {
    value: 10,
    label: "העברה דולרית"
  },
  {
    value: 11,
    label: "העברה אירו"
  },
  {
    value: 12,
    label: "העברה ליש\"ט"
  },
  {
    value: 13,
    label: "דולר קנדי"
  },
  {
    value: 14,
    label: "פיי פל PAY PAL"
  },
  {
    value: 15,
    label: "בנק - פרנק שווי"
  },
  {
    value: 16,
    label: "כתר שוודי"
  }
]

export const currencyListOptions = [
  {
    value: 1,
    label: "ש\"ח"
  },
  {
    value: 2,
    label: "USD"
  },
  {
    value: 3,
    label: "EURO"
  },
  {
    value: 4,
    label: "ליש\"ט"
  },
  {
    value: 5,
    label: "CAD"
  },
  {
    value: 6,
    label: "HUF"
  },
  {
    value: 7,
    label: "פרנק שווצרי"
  },
  {
    value: 8,
    label: "כתר שוודי"
  }
]

export const monthsOptions = [
  {label: 'ינואר', value: 1},
  {label: 'פברואר', value: 2},
  {label: 'מרץ', value: 3},
  {label: 'אפריל', value: 4},
  {label: 'מאי', value: 5},
  {label: 'יוני', value: 6},
  {label: 'יולי', value: 7},
  {label: 'אוגוסט', value: 8},
  {label: 'ספטמבר', value: 9},
  {label: 'אוקטובר', value: 10},
  {label: 'נובמבר', value: 11},
  {label: 'דצמבר', value: 12},
];

export const splitsOptions = [
  {label: '1', value: 1},
  {label: '2', value: 2},
  {label: '3', value: 3},
  {label: '4', value: 4},
  {label: '5', value: 5},
  {label: '6', value: 6},
  {label: '7', value: 7},
];

export const paypalPaymentStatusOptions = [
  {label: 'בתהליך', value: 'pending'},
  {label: 'שולם', value: 'success'},
  {label: 'בוטל', value: 'cancel'},
];

export const sendNotificationTypeOptions = [
  {label: 'מייל', value: 'email'},
  {label: 'סמס', value: 'sms'},
  {label: 'וואטסאפ', value: 'whatsapp'},
];

export const sendNotificationStatusOptions = [
  {label: 'בתהליך', value: 'pending'},
  {label: 'הצלחה', value: 'success'},
  {label: 'להיכשל', value: 'fail'},
];